import React, { useEffect, useState } from 'react';
import { useFrame, useLoader } from '@react-three/fiber'
/* @ts-ignore */
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { CuboidCollider, RigidBody } from '@react-three/rapier';
import { useGameController } from './hooks/useGameController.ts';
import { Color, MeshStandardMaterial } from 'three';
import { applyRealisticMaterials, applyNaturalMaterials } from './utils/materialUtils.ts';

const models = {
    laptop: "data/models/Laptop/laptop.gltf",
    campfire: "data/models/campfire.gltf",
    tree: "data/models/tree.gltf",
    garden: "data/models/garden.gltf",
}

export default function Prop({ id, position, scale, rotation, item, uid}) {
    const { scene } = useLoader(GLTFLoader, models[id])

    useEffect(() => {
        if(item.data.renderType === 'blueprint'){
            scene.traverse((child) => {
            if (child.isMesh) {
                child.oldMaterial = child.material;
                child.material = new MeshStandardMaterial({
                    color: new Color(0x5555ff), // Blue color
                    transparent: true,
                    opacity: 0.5,
                  });
                
            }
            });
        } else {
            scene.traverse((child) => {
            if (child.isMesh) {
                child.material = child.oldMaterial || child.material;
                // Enable shadows on prop meshes
                child.receiveShadow = true;
                child.castShadow = true;
            }
            });
            
            // Apply realistic materials based on prop type
            if (id === 'tree' || id === 'garden') {
                applyNaturalMaterials(scene);
            } else {
                applyRealisticMaterials(scene);
            }
        }
      }, [scene, uid, item.data.renderType]);
    
    return  item.data.renderType === 'blueprint' ? (
        <primitive position={position} rotation={rotation} scale={scale} object={scene} args={[0,0,0]}/>
    ) : (
        
        <RigidBody position={position} rotation={rotation} scale={scale} type="fixed"  colliders="trimesh">
            <primitive object={scene} position={[0,0,0]} receiveShadow />
        </RigidBody>
    )
  
};